import React, { useContext, useEffect } from 'react';
import { Button, Table, Icon, Container } from 'semantic-ui-react';
import * as XLSX from 'xlsx'
import { IUnifyJob } from '../../../app/models/unifyjob';
import unifyJobsStore from '../../../app/stores/unifyjobsStore';
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';


const UnifyJobCreateForm: React.FC<RouteComponentProps> = ({
  match,
  history
}) => {
  const unifyjobsStore = useContext(unifyJobsStore);
  const {
    createUnifyJob,
    submitting,
    importUnifyJobs,
    unifyjobList,
    clearUnifyJob
  } = unifyjobsStore;

  useEffect(() => {

    return () => {
      clearUnifyJob();
    };
  }, []);

  const handleSubmit = () => {
    createUnifyJob(unifyjobList).then(() => history.push(`/financemanagement/unifyjob`));
  };

  const readExcel=(file: any)=> {
    const promise = new Promise((resolve, reject) => {
    const fileReader = new FileReader();
   fileReader.readAsBinaryString(file[0]);

    fileReader.onload = () => {
      // const bufferArray = e.target!.result;
      const bufferArray = fileReader.result;
      const wb = XLSX.read(bufferArray, {type: 'binary'});
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws);

      resolve(data);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
    });

    promise.then((data) => {
      console.log(data);
      importUnifyJobs(data);
    }).catch((error) => console.log(error));
  }
  var i = 0;
  return (
    <Container fluid>
      <Button as="label" htmlFor="file" type="button" color='blue' size='small'>
        <Icon name='file excel' />
        Import
      </Button>
      <input type="file" id="file" accept='.xlsx, .xls, .csv' hidden
        onChange={(e) => {
          const file = e.target.files;
          readExcel(file);
        }} />
        <Button
          loading={submitting}
          floated='right'
          color='green'
          onClick={handleSubmit}
          content='Submit'
        />

      <Table celled>
        <Table.Header>
          <Table.Row>
          <Table.HeaderCell>No.</Table.HeaderCell>
          <Table.HeaderCell>Financial Year</Table.HeaderCell>
          <Table.HeaderCell>Pay Run</Table.HeaderCell>
            <Table.HeaderCell>Work Order ID</Table.HeaderCell>
            <Table.HeaderCell>Technician</Table.HeaderCell>
            <Table.HeaderCell>Start Date</Table.HeaderCell>
            <Table.HeaderCell>Hours</Table.HeaderCell>
            <Table.HeaderCell>SOR ID</Table.HeaderCell>
            <Table.HeaderCell>Work Order Lines Description</Table.HeaderCell>
            <Table.HeaderCell>Comments</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {unifyjobList.map(unifyjob => {
              i = i + 1;
          return     <Table.Row key={unifyjob.id}>
              <Table.Cell>
                {i}
              </Table.Cell>
              <Table.Cell>{unifyjob.financialYear}</Table.Cell>
              <Table.Cell>{unifyjob.payRun}</Table.Cell>
              <Table.Cell>{unifyjob.workOrderNumber}</Table.Cell>
              <Table.Cell>{unifyjob.tech}</Table.Cell>
              <Table.Cell>{unifyjob.startDate.substr(8,2) + '/' +
               unifyjob.startDate.substr(5,2) + '/' + unifyjob.startDate.substr(0,4)}</Table.Cell>
              <Table.Cell>{unifyjob.hours}</Table.Cell>
              <Table.Cell>{unifyjob.sorId}</Table.Cell>
              <Table.Cell>{unifyjob.description}</Table.Cell>
              <Table.Cell>{unifyjob.comment}</Table.Cell>
            </Table.Row>;
             })}
        </Table.Body>
      </Table>
      
    </Container>
  );
};

export default observer(UnifyJobCreateForm);
